;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.promoResize = (function () {
    const DISABLED_FOR_NOW = true

    const initialize = function () {
      const adjustPromoHeight = function () {
        if (DISABLED_FOR_NOW) { return }
        const $promos = $('.promo-block').not('.permanent')
        $promos.each(function (index, el) {
          const $el = $(el)
          const currentHeight = $el.find('.promo-image').outerHeight()
          // console.log('Current height of image ' + index + ' is ' + currentHeight, $el);
          $el.find('.promo-content').height(currentHeight)
        })
      }

      if ($('.promo-block-wrapper').length) {
        $(window).resize(adjustPromoHeight)
        $(document).ready(adjustPromoHeight)
      }

      const adjustPermPromoHeight = function () {
        if (DISABLED_FOR_NOW) { return }
        const $promos = $('.promo-block.permanent')
        $promos.each(function (index, el) {
          const $el = $(el)
          const currentHeight = $el.find('.promo-image').outerHeight()
          // console.log('Current height of images is ' + currentHeight);
          // console.log('Current height of image ' + index + ' is ' + currentHeight, $el);
          $el.find('.promo-content').height(currentHeight)
        })
      }

      if ($('.homepage-promos').length) {
        $(window).resize(adjustPermPromoHeight)
        $(document).ready(adjustPermPromoHeight)
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.promoResize.initialize()
  })
}(jQuery, window))
